import { render, staticRenderFns } from "./WhInventoryXaRecord.vue?vue&type=template&id=594f7358&scoped=true"
import script from "./WhInventoryXaRecord.vue?vue&type=script&lang=js"
export * from "./WhInventoryXaRecord.vue?vue&type=script&lang=js"
import style0 from "./WhInventoryXaRecord.vue?vue&type=style&index=0&id=594f7358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594f7358",
  null
  
)

export default component.exports